<div *ngIf="transportOrder" class="row mb-3">
  <div class="col-12 col-md-6 mb-3 mb-md-0">
    <jhi-bary-card titleKey="TRANSPORT_ACTIONS.TITLE">
      <div body>
        <button
          size="sm"
          mdbBtn
          color="danger"
          class="waves-light"
          mdbWavesEffect
          (click)="deleteTransport()"
          *ngIf="isDeletable && transportOrder.deliveryStatus?.code !== DELIVERY_STATUS_CANCELED"
        >
          <span jhiTranslate="BTN.CANCEL">Annuler</span>
        </button>
        <button size="sm" *ngIf="hasEdi" mdbBtn color="main" class="waves-light" mdbWavesEffect (click)="sendEdi()">
          <span jhiTranslate="BTN.RESEND_EDI"> Renvoyer l'EDI</span>
        </button>
        <span [mdbTooltip]="this.tooltip">
          <button
            size="sm"
            [disabled]="isDisabledButtonModify() || this.isQuotation || transportOrder.isFTL()"
            type="button"
            color="primary"
            (click)="goToUpdateTransport()"
            mdbBtn
            mdbWavesEffect
          >
            <mdb-icon fas icon="pencil" class="mr-1"></mdb-icon>
            <span jhiTranslate="BTN.UPDATE">Modifier</span>
            <mdb-icon *ngIf="isDisabledButtonModify() || this.isQuotation || transportOrder.isFTL()" fas icon="circle-info" class="ml-1"></mdb-icon>
          </button>
        </span>
        <button *ngIf="transportOrder.deliveryStatus != 'DELIVERED'" mdbBtn color="success" size="sm" class="waves-light" mdbWavesEffect (click)="confirmDelivery()">
          <mdb-icon fas icon="clipboard-check" class="mr-1"></mdb-icon>
          <span jhiTranslate="BTN.CONFIRM_DELIVERY">Confirmer la livraison</span>
        </button>
      </div>
    </jhi-bary-card>
  </div>
  <div class="col-12 col-md-6 mb-md-0">
    <jhi-transport-edi-history [transportOrderId]="transportOrder.id"></jhi-transport-edi-history>
  </div>
</div>
